/** @jsx jsx */
import { jsx, css } from '@emotion/core';

import React, { FC, Fragment } from 'react';
import {
  TextareaAutosize,
  TextareaAutosizeProps,
  FormHelperText,
  InputLabel,
  FormControl,
} from '@material-ui/core';
import colors from '../../../themes/main-colors';

type TextAreaInputProps = TextareaAutosizeProps & {
  errorMsg?: string;
  inputLabel?: string;
};

const styles = css`
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  min-height: 80px;
  height: 80px;
  max-height: 180px;
  font-family: inherit;
  font-size: inherit;
  font-weight: 400;
  line-height: 1.5;
  padding: 20px 12px 12px 12px;
  border-radius: 5px;
  color: currentColor;
  background: transparent;
  border-color: ${colors.boxShadowBlack};

  &:hover {
    border-color: ${colors.black};
  }

  &:focus {
    border-color: ${colors.sparkBlue};
    box-shadow: 0 0 0 1px ${colors.sparkBlue};
  }

  // firefox
  &:focus-visible {
    outline: 0;
  }
`;

export const TextAreaInput: FC<TextAreaInputProps> = ({
  rowsMax = 4,
  errorMsg = '',
  inputLabel,
  ...props
}: TextAreaInputProps) => {
  return (
    <Fragment>
      <FormControl
        css={{
          position: 'relative',
          width: '100%',
        }}
      >
        <InputLabel
          css={{
            position: 'absolute',
            transform: 'translate(14px, -8px) scale(1)',
            fontSize: '14px',
            background: colors.siteBackground,
            padding: '0 2px',
            width: '90%',
            color: `${colors.sparkBlue} !important`,
          }}
        >
          {inputLabel}
        </InputLabel>
        <TextareaAutosize
          {...props}
          rowsMax={rowsMax}
          maxLength={500}
          css={styles}
        />
      </FormControl>
      {errorMsg && <FormHelperText error>{errorMsg}</FormHelperText>}
    </Fragment>
  );
};
